import { render, staticRenderFns } from "./SelectPayment.vue?vue&type=template&id=6bcef066&scoped=true&"
import script from "./SelectPayment.vue?vue&type=script&lang=ts&"
export * from "./SelectPayment.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPayment.vue?vue&type=style&index=0&id=6bcef066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcef066",
  null
  
)

export default component.exports